export const INVISIBLE_DURATION = "$0x1";
export const INVISIBLE_DURATION_EVENT = "$0x2";
export const INVISIBLE_START_EVENT = "$0x3";
